import React from "react";
import MicRecorder from "mic-recorder-to-mp3";
import MicIcon from "@mui/icons-material/Mic";
import StopIcon from "@mui/icons-material/Stop";
import Fab from "@mui/material/Fab";

const Mp3Recorder = new MicRecorder({ bitRate: 320 });

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isRecording: false,
      blobURL: "",
      isBlocked: false,
    };
  }

  start = () => {
    this.props.handleStart();
    if (this.state.isBlocked) {
      console.log("Permission Denied");
    } else {
      Mp3Recorder.start()
        .then(() => {
          this.setState({ isRecording: true });
        })
        .catch((e) => console.error(e));
    }
  };

  stop = () => {
    this.props.handleStop();
    this.props.handleReset();
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const blobURL = URL.createObjectURL(blob);
        this.setState({ blobURL, isRecording: false });
        return blob.arrayBuffer();
      })
      .then((data) => {
        this.props.setAudio(data);
      })
      .catch((e) => console.log(e));
  };

  componentDidMount() {
    navigator.getUserMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia ||
      navigator.mediaDevices.getUserMedia;
    navigator.getUserMedia(
      { audio: true },
      () => {
        console.log("Permission Granted");
        this.setState({ isBlocked: false });
      },
      () => {
        console.log("Permission Denied");
        this.setState({ isBlocked: true });
      }
    );
  }

  render() {
    return (
      <div style={{ margin: "5%" }}>
        <div
          style={{
            marginBottom: "5%",
            height: "auto",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            textAlign: "center",
            alignContent: "center",
          }}
        >
          {!this.state.isRecording ? (
            <Fab
              style={{ backgroundColor: "red" }}
              onClick={this.start}
              disabled={this.state.isRecording}
              color="primary"
              aria-label="add"
            >
              <MicIcon />
            </Fab>
          ) : (
            <Fab
              onClick={this.stop}
              disabled={!this.state.isRecording}
              color="primary"
              aria-label="add"
            >
              <StopIcon />
            </Fab>
          )}
        </div>
        {this.state.isRecording ? (
          <div
            style={{
              marginBottom: "5%",
              margin: "auto",
              width: "15%",
              height: "auto",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              textAlign: "center",
              alignContent: "center",
            }}
          >
            <span>{this.props.minutes}</span>
            {":"}
            <span>{this.props.seconds}</span>
          </div>
        ) : this.state.blobURL !== "" && !this.props.isRecording ? (
          <audio
            style={{ width: "100%" }}
            src={this.state.blobURL}
            controls="controls"
          />
        ) : null}
      </div>
    );
  }
}

export default App;
